import React from 'react';
import { Laptop, Server, Database } from 'lucide-react';

/**
 * Компонент для параметров технологического обеспечения
 */
const TechnologySection = ({ 
  formData, 
  handleInputChange, 
  errors
}) => {
  return (
    <div className="mb-6 bg-purple-50 dark:bg-purple-900/20 p-4 rounded-lg border border-purple-200 dark:border-purple-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Laptop className="w-5 h-5 mr-2 text-purple-500" />
        Технологическое обеспечение
      </h3>
      
      {/* Программное обеспечение */}
      <div className="mb-4">
        <div className="flex items-center justify-between mb-3">
          <label className="inline-flex items-center text-sm font-medium text-gray-700 dark:text-gray-300">
            <Database className="w-4 h-4 mr-2 text-purple-500" />
            <span>Программное обеспечение</span>
          </label>
          <label className="inline-flex items-center text-sm text-gray-700 dark:text-gray-300">
            <input
              type="checkbox"
              name="softwareImplementation"
              checked={formData.softwareImplementation}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2">Включить в расчет</span>
          </label>
        </div>
        
        {formData.softwareImplementation && (
          <div className="pl-6 grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Тип ПО */}
            <div>
              <label htmlFor="softwareType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Тип программного обеспечения
              </label>
              <select
                id="softwareType"
                name="softwareType"
                value={formData.softwareType}
                onChange={handleInputChange}
                className={`form-select w-full ${errors.softwareType ? 'input-error' : ''}`}
              >
                <option value="custom">Заказная разработка</option>
                <option value="off-the-shelf">Готовое решение</option>
                <option value="hybrid">Гибридное решение</option>
              </select>
              {errors.softwareType && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.softwareType}
                </p>
              )}
            </div>

            {/* Стоимость ПО */}
            <div>
              <label htmlFor="softwareCost" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Бюджет на ПО (руб.)
              </label>
              <input
                type="text"
                id="softwareCost"
                name="softwareCost"
                value={formData.softwareCost}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.softwareCost ? 'input-error' : ''}`}
                placeholder="Оценочная стоимость"
              />
              {errors.softwareCost && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.softwareCost}
                </p>
              )}
            </div>
          </div>
        )}
      </div>
      
      {/* Аппаратное обеспечение */}
      <div>
        <div className="flex items-center justify-between mb-3">
          <label className="inline-flex items-center text-sm font-medium text-gray-700 dark:text-gray-300">
            <Server className="w-4 h-4 mr-2 text-purple-500" />
            <span>Аппаратное обеспечение и инфраструктура</span>
          </label>
          <label className="inline-flex items-center text-sm text-gray-700 dark:text-gray-300">
            <input
              type="checkbox"
              name="hardwareUpgrades"
              checked={formData.hardwareUpgrades}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2">Включить в расчет</span>
          </label>
        </div>
        
        {formData.hardwareUpgrades && (
          <div className="pl-6">
            <div>
              <label htmlFor="hardwareCost" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Бюджет на оборудование (руб.)
              </label>
              <input
                type="text"
                id="hardwareCost"
                name="hardwareCost"
                value={formData.hardwareCost}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.hardwareCost ? 'input-error' : ''}`}
                placeholder="Оценочная стоимость"
              />
              {errors.hardwareCost && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.hardwareCost}
                </p>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Пояснения по технологическому обеспечению */}
      <div className="mt-4 bg-purple-100 dark:bg-purple-900/30 p-3 rounded-lg border border-purple-200 dark:border-purple-800">
        <p className="text-xs text-purple-700 dark:text-purple-300">
          <span className="font-medium">Важно!</span> Технологическое обеспечение может составлять значительную часть бюджета 
          трансформации. При выборе заказной разработки ПО учитывайте не только стоимость разработки, но и внедрения, 
          интеграции и поддержки. Для готовых решений также необходимо учесть лицензионные платежи и стоимость 
          кастомизации.
        </p>
      </div>
    </div>
  );
};

export default TechnologySection;